export default __webpack_public_path__ + "static/media/eqipment.21c454d2.png";